import styled from 'styled-components';

export const PageWrapper = styled.div`
    background: radial-gradient(89.48% 373.44% at 92.67% 89.43%, #005242 32.71%, #006451 100%);
`

export const TopSection = styled.div`
    display: flex;
    align-items: center; 
    justify-content: space-between;
    padding: 80px 0;

    img {
        max-width: 580px;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 0px 0 80px;
        img {
            max-width: 100%;
        }
    }
`

export const TopSectionMain = styled.div`
    max-width: 460px;
    margin: 0 auto;
    padding: 44px 0px;

    h1 {
        font-size: 54px;
        font-weight: 700;
        line-height: 1.1;
        margin-bottom: 20px;
        color: #fff;
    }

    p {
        font-size: 17px;
        color: #fff;
        line-height: 25px;
        letter-spacing: 0.5px;
    }

    .home-p {
        font-family: sans-serif;
    }

    @media (max-width: 991px) {
        h1 {
            font-size: 36px;
            font-weight: 700;
            line-height: 44px;
            margin-bottom: 24px;
        }

        p {
            margin-bottom: 24px;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`


export const SectionContent = styled.div`
    padding: 80px 0px;
    text-align: center;

    h2 {
        font-size: 40px;
        line-height: 50px;
        color: #212529;
        font-weight: 700;
    }

    h3 {
        font-size: 24px;
        line-height: 30px;
        color: #299B85;
        font-weight: 700;
    }


    p {
        max-width: 460px;
        display: block;
        margin: 0 auto 20px;
        font-size: 16px;
        line-height: 24px;
        color: #666666;
    }

    @media (max-width: 768px) {
        padding: 40px 0;

        h2 {
            font-size: 22px;
        }

        p {
            max-width: 100%;
        }

        button {
            margin-bottom: 15px;
        }
    }
`

export const PartnerSection = styled.div`
    padding: 80px 0;

    h2 {
        text-align: center;
        font-weight: 700;
        font-size: 36px;
        line-height: 42px;
        max-width: 50%;
        display: block;
        margin: 0 auto 30px;
    }

    @media (max-width: 768px) {
        padding: 40px 0;

        h2 {
            max-width: 80%;
            font-size: 22px;
            line-weight: 36px;
        }
    }
`